import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  token: '',
  message: '',
};

// Async thunks for CREATE operations
export const login = createAsyncThunk('login', async (payload) => {
  return await loginApi(payload);
});

const loginSlice = createSlice({
  name: 'login', // Unique Name
  initialState,
  reducers: {
    loginReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
        state.token = '';
      })
      .addCase(login.fulfilled, (state, action) => {
        const { message = '', token = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.token = token;
      })
      .addCase(login.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { loginReset } = loginSlice.actions;

export default loginSlice.reducer;
